import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import FamilyRoomService from "../../../../services/rates/FamilyRoomService";

export const REQUEST_UPDATE_FAMILY_ROOM = "REQUEST_UPDATE_FAMILY_ROOM";
export const UPDATE_FAMILY_ROOM_SUCCESS = "UPDATE_FAMILY_ROOM_SUCCESS";
export const UPDATE_FAMILY_ROOM_ERROR = "UPDATE_FAMILY_ROOM_ERROR";

function requestUpdateFamilyRoom() {
  return {
    type: REQUEST_UPDATE_FAMILY_ROOM,
  };
}

function updateFamilyRoomSuccess(json) {
  return {
    type: UPDATE_FAMILY_ROOM_SUCCESS,
    message: json.data,
  };
}

function updateFamilyRoomError(json) {
  return {
    type: UPDATE_FAMILY_ROOM_ERROR,
    error: json.data,
  };
}

export function updateFamilyRoom(family_room_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateFamilyRoom());
    return FamilyRoomService.putFamilyRoom(family_room_id, payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(updateFamilyRoomSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(updateFamilyRoom(family_room_id, payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(updateFamilyRoomError(json.data));
        }
      }
    );
  };
}
